<template>
    <div
        class="md-map broker"
        v-if="show && lat && lng && !isHideSchoolMap"
        :style="{ marginBottom }"
    >
        <module-box
            :fullColumn="fullColumn"
            :topSpacing="topSpacing"
            :btmSpacing="btmSpacing"
            :mobileNoMargin="mobileNoMargin"
            :mobileTopSpacing="mobileTopSpacing"
            :mobileBtmSpacing="mobileBtmSpacing"
            noPadding
            noMargin
        >
            <div v-if="title" class="mg-title" v-html="formatFontSize(title, '--mg-title-size')"></div>
            <div class="map-content">
                <div
                    class="map-container"
                    :class="{
                        noscore: !(
                            listingWalkScore && listingWalkScore.walkscore > 0
                        ),
                        expand: visible
                    }"
                    :style="containerStyle"
                >
                    <div v-if="replace" class="map-replace">
                        <iframe
                            frameborder="0"
                            scrolling="no"
                            marginheight="0"
                            marginwidth="0"
                            :src="`https://maps.google.com/maps?q=${lat},${lng}&z=${
                                parseInt(zoom) || 14
                            }&output=embed`"
                            :style="{
                                width: showGMap ? '100%' : '0%',
                                height: '100%'
                            }"
                            @load="replaceMapLoad = true"
                        ></iframe>
                    </div>
                    <component
                        :is="componentName"
                        v-else-if="canLoadMap && mapShow"
                        :zoom="zoom"
                        :mapConfig="mapConfig"
                        :tools="calTools"
                        :center="center"
                        :address="address"
                        :autoCenter="autoCenter"
                        :mapChangeEvent="mapChangeEvent"
                        :markerData="markerData"
                        :markerEventMap="markerEventMap"
                        @mapLoad="mapLoad"
                        @click="mapClick"
                    ></component>
                </div>
                <map-tab
                    v-if="tabs && tabs.length"
                    :showCollapse="showCollapse"
                    v-model:replace="replace"
                    :tabs="tabs"
                    :selectTab="selectTab"
                    :houseLimit="houseLimit"
                    @updateMarkerEvent="updateMarkerEvent"
                    @updateMarkerData="updateMarkerData"
                    @doMapEvent="doMapEvent"
                    @visible="handleVisible"
                    @updateMapClickEvent="updateMapClickEvent"
                ></map-tab>
            </div>
            <AttomDesc v-if="showDisclaimer" class="near-by-disclaimer" :content="$t('md-map.schoolDataProvided')" />
        </module-box>
    </div>
</template>

<script>
import { mapState as rootMapState } from 'pinia';
import { usePageStore } from '@/store';
import { defineAsyncComponent } from 'vue';
import common from '../index';
import mapTab from './map-tab.vue';

export default {
    mixins: [common],
    computed: {

        ...rootMapState(usePageStore, {
            'page': store => store.page || {}
        }),
        calTools() {
            if (this.isMobileSize && this.listingWalkScore && this.scoreTools) {
                return this.scoreTools;
            } else {
                return this.tools;
            }
        },
        
        componentName({ page }) {
            return page.map?.type === 'google' ? 'Map' : 'hereMap';
        }
    },
    components: {
        Map: defineAsyncComponent(() =>
            import(
                /* webpackChunkName: "map_broker"*/ '@/components/map/broker.vue'
            )),
        hereMap: defineAsyncComponent(() =>
            import(
                /* webpackChunkName: "map-here_broker"*/ '@/components/map-here/broker.vue'
            )),
        mapTab
    }
};
</script>

<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';

.md-map.broker {
    @include media-600 {
        .mg-container {
            overflow: visible;
        }
    }
    .mg-title {
        font: 24px var(--mg-title-font);
        padding-bottom: 20px;
        @include media-600 {
            font: 16px var(--mg-title-font);
        }
    }
    .map-content {
        display: flex;
        height: 450px;
        position: relative;
        .map-container {
            flex-grow: 1;
            height: 100%;
            position: relative;
            .work-score {
                display: flex;
                align-items: center;
                position: absolute;
                left: 10px;
                bottom: 10px;
                max-width: calc(100% - 70px);
                height: 58px;
                padding: 0 20px;
                background-color: #fff;
                font-size: 12px;
                z-index: 1;
                .score {
                    font-family: var(--font-bold);
                    font-size: 30px;
                    margin-right: 10px;
                }
                .label {
                    font-family: var(--font-medium);
                    line-height: 1.1;
                    margin-right: 20px;
                }
                .info {
                    font-size: 14px;
                    @include webkitBox(2);
                }
            }
            .map-replace {
                position: absolute;
                left: 0;
                right: 0;
                top: 0;
                bottom: 0;
            }
            &.expand {
                @include media-min-600 {
                    .map-box .map-tool.map-type {
                        left: 440px !important;
                    }
                }
            }
            .zoom.standard .zoom-in:before,
            .zoom.standard .zoom-in:after,
            .zoom.standard .zoom-out:before,
            .zoom.standard .zoom-out:after {
                background-color: #191919;
            }
            .site-map.broker .marker-icon .marker-pop {
                background-color: #fff;
                color: #191919;
                font-size: 14px;
                font-family: var(--font-normal);
                box-shadow: 0 2px 10px 0 rgba(0, 10, 30, 0.1);
                .pointer {
                    border-top-color: #fff;
                }
            }

            .site-map.broker .map-marker.school:not(.location).active {
                box-shadow: 0px 0px 0px 20px rgba(#ff781d, 0.1);
                border-radius: 50%;
                .iconfont {
                    color: #ff781d !important;
                    &:after {
                        background-color: #ff781d;
                    }
                    &:before {
                        color: #fff;
                    }
                }
            }
            .site-map.broker .marker-icon.school:not(.location).iconfont:hover {
                color: #ff781d !important;
            }
        }
        @include media-600 {
            height: auto;
            display: block;
            .map-container {
                width: 100%;
                height: 100vw;
                border-top: 1px solid #f0f1f5;
                border-bottom: 1px solid #f0f1f5;
                .work-score {
                    top: 0;
                    bottom: initial;
                    width: 100%;
                    max-width: none;
                    left: 0;
                    padding: 0 15px;
                    opacity: 0.9;
                    .info {
                        flex: 1;
                        text-align: right;
                    }
                }
                .gm-style .gmnoprint .gm-style-mtc {
                    margin-top: 68px;
                }
                .map-replace {
                    top: 58px;
                }
                &.noscore {
                    .gm-style .gmnoprint .gm-style-mtc {
                        margin-top: 10px;
                    }
                    .map-replace {
                        top: 0;
                    }
                }
            }
        }
    }
    .near-by-disclaimer {
        padding: 10px 0 0 0;
        color: #a8a8a8;
        font-size: 12px;
        font-family: var(--font-normal);
        line-height: 16px;
        a.disclaimer {
            text-decoration: underline;
            @include color-theme();
        }
        @include media-600 {
            margin-top: 20px;
            border-top: 1px solid var(--color-border);
            padding: 10px 0;
        }
    }
    .gm-style-pbc {
        z-index: 4 !important;
        pointer-events: none;
    }
}
</style>
